import gql from 'graphql-tag';

export default gql`
mutation($isButtonDisabled: Boolean!) {
  setButtonDisabled(isButtonDisabled: $isButtonDisabled) @client
}
`;
